export const Flash = {
  supported() {
    let hasFlash = false;

    try {
      const fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
      if (fo) {
        hasFlash = true;
      }
    } 
    catch (e) {
      if (window.navigator.mimeTypes && 
          window.navigator.mimeTypes['application/x-shockwave-flash'] !== undefined && 
          window.navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin) {
        hasFlash = true;
      }
    }

    return hasFlash;
  }
};

// https://coderwall.com/p/i817wa/one-line-function-to-detect-mobile-devices-with-javascript
export const isMobile = 'orientation' in window || window.navigator.userAgent.indexOf('IEMobile') !== -1;


// WEBPACK FOOTER //
// ./src/Services/Misc/environment.js